import { useEffect, useRef } from "react";
import * as React from "react";
import { Col, Form, Input, InputRef, Radio, Row, Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import FormHeader from "../FormHeader";
import IconButton from "../../ui/IconButton";
import { BaseCurrencySelectionType, BaseCurrencyValue, CurrencyPlaceholderName } from "../../../types/newLinkBuilder";
import useFetchCurrencies from "../../../utils/useFetchCurrencies";
interface BaseCurrencyFormProps {
    baseCurrencyValue: BaseCurrencyValue;
    setBaseCurrencyValue: (value: BaseCurrencyValue) => void;
    handlePlaceholder: (name: CurrencyPlaceholderName) => void;
    currencyOptions: { label: string; value: string }[];
}

const BaseCurrencyForm: React.FC<BaseCurrencyFormProps> = ({ baseCurrencyValue, setBaseCurrencyValue, handlePlaceholder, currencyOptions }) => {
    const baseCurrencyValueRef = useRef<any>(null);
    const handleBaseCurrencyChange = (field: keyof BaseCurrencyValue, value: string) => {
        setBaseCurrencyValue({ ...baseCurrencyValue, [field]: value });
    }

    useEffect(() => {
        baseCurrencyValueRef.current?.focus()
    }, [])

    return (
        <>
            <FormHeader title="Base Currency" />
            <Form.Item name={"baseCurrency"}>
                <Radio.Group
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                    }}
                    options={[{
                        value: BaseCurrencySelectionType.Value,
                        label: (
                            <Row
                                align={"middle"}
                            >
                                <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <span>Value</span>
                                </Col>

                                <Col span={18} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <Select
                                        placeholder="Currency"
                                        disabled={baseCurrencyValue.selected === BaseCurrencySelectionType.CellReference}
                                        ref={baseCurrencyValueRef}
                                        value={baseCurrencyValue.currency}
                                        onChange={(value) => handleBaseCurrencyChange("currency", value)}
                                        style={{ width: "100%" }}
                                        onClick={(e) => e.preventDefault()}

                                        showSearch
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        options={currencyOptions}
                                    />
                                </Col>

                            </Row>
                        )
                    }, {
                        value: BaseCurrencySelectionType.CellReference,
                        label: (
                            <Row
                                align={"middle"}
                            >
                                <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <span>Cell Reference</span>
                                </Col>

                                <Col span={16} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <Input
                                        placeholder="Cell Reference"
                                        disabled={baseCurrencyValue.selected === BaseCurrencySelectionType.Value}
                                        value={baseCurrencyValue.currencyCellReference}
                                        onChange={(e) => handleBaseCurrencyChange("currencyCellReference", e.target.value)}
                                    />
                                </Col>

                                <Col span={2} style={{ display: 'flex', justifyContent: 'end' }}>
                                    <IconButton
                                        disabled={baseCurrencyValue.selected === BaseCurrencySelectionType.Value}
                                        icon={<UploadOutlined />}
                                        onClick={() => handlePlaceholder(CurrencyPlaceholderName.BaseCurrencyCellReference)}

                                    />
                                </Col>
                            </Row>
                        )
                    }
                    ]}
                />
            </Form.Item>
        </>
    );
};

export default BaseCurrencyForm;
